// Map routes to page categories
const PAGE_CATEGORIES = {
    '/': 'auth',
    '/signup': 'auth',
    '/forgot-password': 'auth',
    '/reset-password': 'auth',
    '/logout': 'auth',
    '/dashboard': 'home',
    '/auth/dashboard': 'home',
    '/horoscope-generated': 'horoscope',
    '/horoscope': 'horoscope',
    '/moonsign-select': 'horoscope',
    '/moonsign-lookup': 'horoscope',
    '/rising-sign-lookup': 'horoscope',
    '/profile': 'profile',
    '/my-subscriptions': 'subscription',
    '/payment-plan-select': 'payment',
    '/enter-payment-details': 'payment',
    '/enter-payment-mobile': 'payment',
    '/enter-life-event-payment-mobile': 'payment',
    '/order-confirm': 'payment',
    '/order-complete': 'payment',
    '/one-off-confirmation': 'payment',
    '/one-off-confirmation-mobile': 'payment',
    '/one-off-confirmation-mobile-successfull': 'payment',
    '/consultations': 'consultation',
    '/consultation-detail': 'consultation',
    '/consultation-form': 'consultation',
    '/consultation-confirmation': 'consultation',
    '/gemstones': 'gemstone',
    '/gemstone': 'gemstone',
    '/gemstone-enquiry': 'gemstone',
    '/gemstone-enquiry-success': 'gemstone',
    '/life-events': 'life_events',
    '/life-event-confirmation': 'life_events',
    '/noticeboard': 'notifications',
};

export function getPageCategory(path) {
    // Exact match
    if (PAGE_CATEGORIES[path]) {
        return PAGE_CATEGORIES[path];
    }

    // Partial match (for dynamic routes)
    const matchedEntry = Object.entries(PAGE_CATEGORIES).find(
        ([route]) => path.startsWith(route) && route !== '/',
    );

    if (matchedEntry) {
        return matchedEntry[1];
    }

    // Handle specific dynamic route patterns
    if (path.match(/^\/horoscope\/\w+\/\w+$/)) {
        return 'daily_reading';
    }

    if (path.match(/^\/horoscope\/yearly\/.+$/)) {
        return 'life_events';
    }

    return 'other';
}

export default PAGE_CATEGORIES;
